import React, { useContext, useEffect, useState } from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  getUserProfileAction,
  saveFcm,
} from "../redux/services/auth/authServices";
import useLocalStorage from "../hooks/useLocalStorage";
import RenderServiceProviderAdminRoutes from "./routes/service-provider-admin/renderServiceProviderAdminRoutes";
import renderSuperAdminRoutes from "./routes/super-admin/renderSuperAdminRoutes";
import { appConfig } from "../constants/config/appConfig";
import { routes } from "../constants";
import VerificationDialog from "../component/common/verification-dialog";
import SuspensionDialogn from "../component/common/suspension-dialog";
import { UpdateBankAccount } from "../component/pages/service-provider-admin";
import DeleteAccount from "../component/pages/delete-account";
import Easter from "../component/common/tile/Easter";
import { LanguageContext } from "../context/LanguageProvider";
import { useTranslation } from "react-i18next";
import { ConfigProvider } from "antd";
import generateAntdTheme from "../assets/styles/theming/theme";
import { generateToken, messaging } from "../notifications/firebase";
import { onMessage } from "firebase/messaging";
import Actions from "../redux/actions";
import { toastService } from "../component/common/toast-messages/toast";

const App = () => {
  /* dispatch an action */
  const dispatch = useDispatch();
  /* dispatch an action */
  const { i18n } = useTranslation();

  const { updateLanguage } = useContext(LanguageContext);

  /* local storage dependencies */
  const { userSession, setUserSession } = useLocalStorage(
    appConfig.SESSION_USER_INFO
  );
  /* local storage dependencies */

  useEffect(() => {
    userSession &&
      Object.keys(userSession).length !== 0 &&
      userSession !== null &&
      userSession !== undefined &&
      dispatch(getUserProfileAction(setUserSession, updateLanguage));
    // eslint-disable-next-line react-hooks/exhaustive-deps

    generateToken();
    onMessage(messaging, (payload) => {
      toastService.notification(
        payload.notification.title,
        payload.notification.body
      );
    });
  }, []);

  let fcmToken = localStorage.getItem("FCM_TOKEN");
  useEffect(() => {
    if (userSession) {
      let requestBody = {
        token: fcmToken,
        device_id: userSession.userId,
      };
      saveFcm(requestBody);
    }
  }, [userSession, fcmToken]);

  const antdTheme = generateAntdTheme(
    i18n.language === "ar" ? "arabic-poppins" : "Poppins"
  );

  return (
    <>
      <ConfigProvider theme={antdTheme}>
        <Routes>
          <Route path="web-app/delete-account" element={<DeleteAccount />} />

          <Route
            path={routes.DEFAULT_BASE_REDIRECT}
            element={<Navigate to={routes.DEFAULT_THROW} />}
          />
          <Route
            path={routes.DEFAULT_WEB_REDIRECT}
            element={<RenderServiceProviderAdminRoutes />}
          />

          <Route
            path={routes.DEFAULT_SUPER_ADMIN_WEB_REDIRECT}
            element={renderSuperAdminRoutes()}
          />
          <Route path={routes.EASTER} element={<Easter />} />
        </Routes>

        <VerificationDialog />
        <SuspensionDialogn />
      </ConfigProvider>
    </>
  );
};

export default App;
